export default __webpack_public_path__ + "static/media/group1.212a4b1e.png";